import { json, useLoaderData, useRouteLoaderData } from "react-router-dom";
import { get, patch } from "../apiClient";
import useTitle from "../hooks/useTitle";
import { useScrollToTop } from "../hooks/useScrollToTop";
import GlobalProgrammaticMarginSection from "./../features/programmatic_supply/GlobalProgrammaticMarginSection";
import GlobalDefaultBidfloorSection from "./../features/programmatic_supply/GlobalDefaultBidfloorSection";
import GlobalAllowedCountriesSection from "./../features/programmatic_supply/GlobalAllowedCountriesSection";

const loader = async ({ params, request }) => {
  try {
    const settings = await get(
      "player",
      "/api/programmatic_supply/global_settings",
      { signal: request.signal }
    );

    return settings;
  } catch (error) {
    throw json(
      {
        title: "There was an error fetching global settings from the server",
        text: " Please try again. If the error is persistent, contact support.",
      },
      { status: error.status }
    );
  }
};

const action = async ({ request }) => {
  const formData = await request.formData();
  const { value, name }= Object.fromEntries(formData);

  try {
    const setting = await patch(
      "player",
      `/api/programmatic_supply/global_settings/${name}`,
      { value },
      { signal: request.signal }
    );

    return setting
  } catch (error) {
    switch(error.status) {
      case 400:
      case 422:
        return json(error.details, { status: error.status });
      default:
        throw error
    }
  }
}

const ProgrammaticSupplyGlobalSettings = () => {
  const { reserved_margin, banner_reserved_margin, default_bidfloor, ...payload } = useLoaderData();
  const { programmatic_supply: programmaticSupplyFlag } = useRouteLoaderData("featureFlagLoader");

  useTitle("Programmatic Supply Configuration > Global Settings");
  useScrollToTop();

  return (
    <>
    <GlobalProgrammaticMarginSection title="Fullscreen Programmatic Margin" {...reserved_margin} name="reserved_margin" />
    <GlobalProgrammaticMarginSection title="Banner Programmatic Margin" {...banner_reserved_margin} name="banner_reserved_margin" />
    {programmaticSupplyFlag?.allowed_countries_enabled && (
      <GlobalAllowedCountriesSection {...payload.allowed_countries} />
    )}
    <GlobalDefaultBidfloorSection {...default_bidfloor} />
    </>
  );
}

export { loader, action };

export default ProgrammaticSupplyGlobalSettings;
